<template>
  <div class="video-card">
    <img class="video-cover" :src="cardData.cover" alt="" />
    <!-- <div class="duration">{{ cardData.duration }}</div> -->
    <div class="video-msg ellipsis_two">{{ cardData.name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {},
};
</script>

<style scoped>
.video-card {
  width: 336px;
  margin-bottom: 38px;
  position: relative;
}

.duration {
  position: absolute;
  right: 18px;
  top: 145px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  font-size: 22px;
  padding: 0 12px;
  border-radius: 17px;
  background: rgba(0, 0, 0, 0.2);
}

.video-card:nth-child(3),
.video-card:nth-child(4) {
  margin-bottom: 0;
}

.video-cover {
  width: 336px;
  height: 189px;
  border-radius: 12px;
  display: block;
}

.video-msg {
  font-size: 28px;
  color: #555;
  line-height: 45px;
  margin-top: 10px;
}
</style>>
